import React, { useEffect, useState } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/thunks";
import _BaseAPIService from "../Services/_BaseAPIService";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!_BaseAPIService.retrieveToken()
  );
  const navigate = useNavigate();
  let inactivityTimer;

  const handleUserActivity = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      // Log out the user after 10 minutes of inactivity
      setIsAuthenticated(false);
      localStorage.clear();
      toast.error("Session Time Out!");
      navigate("/");
    }, 600000); // 10 minutes in milliseconds
  };

  // useEffect(() => {
  //   const userActivityEvents = [
  //     "mousemove",
  //     "mousedown",
  //     "keydown",
  //     "touchstart",
  //   ];
  //   userActivityEvents.forEach((event) => {
  //     document.addEventListener(event, handleUserActivity);
  //   });

  //   // Initial token fetch
  //   // updateToken();

  //   return () => {
  //     userActivityEvents.forEach((event) => {
  //       document.removeEventListener(event, handleUserActivity);
  //     });
  //   };
  // }, []);

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    Navigate is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
